import { render } from "./Gameplay.vue?vue&type=template&id=597a12e1"
import script from "./Gameplay.vue?vue&type=script&lang=js"
export * from "./Gameplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/profile/settings/Gameplay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "597a12e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('597a12e1', __exports__)) {
    api.reload('597a12e1', __exports__)
  }
  
  module.hot.accept("./Gameplay.vue?vue&type=template&id=597a12e1", () => {
    api.rerender('597a12e1', render)
  })

}


export default __exports__